"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMessageHead = void 0;
var cookie_1 = require("./cookie");
var json_util_1 = require("./json-util");
function createMessageHead(options, otherParams) {
    var _a, _b;
    var baseRev = otherParams.baseRev, taskId = otherParams.taskId, command = otherParams.command, additionalFieldsToHead = otherParams.additionalFieldsToHead, getHeaderGeneralPacket = otherParams.getHeaderGeneralPacket;
    var serverVars = options.serverVars, nowUserIndex = options.nowUserIndex;
    var sessionType = Number(options.userid.startsWith('g')); // g开头是访客
    var uid = options.uid || options.userid.replace('p.', '').replace('g.', '');
    var head = {
        type: command,
        uid: uid,
        task_id: taskId,
        session_type: sessionType,
        u: nowUserIndex !== null && nowUserIndex !== void 0 ? nowUserIndex : window.nowUserIndex,
        base_rev: baseRev,
        generalpacket: getHeaderGeneralPacket,
        apid: serverVars.apid,
        docid: serverVars.globalPadId,
        code_ver: (_a = serverVars.pver) !== null && _a !== void 0 ? _a : 0,
        gray: (_b = serverVars.gray) !== null && _b !== void 0 ? _b : 0,
        dver: serverVars.dver,
        docs_type: serverVars.padType,
        wl: cookie_1.Cookie.get('wl'),
        cookie: cookie_1.getCookieForMessage(),
    };
    // 将业务侧字段携带到 head里，注意之类，仅做浅拷贝
    head = Object.assign(additionalFieldsToHead !== null && additionalFieldsToHead !== void 0 ? additionalFieldsToHead : {}, head);
    return json_util_1.JsonUtil.jsonStringify(head);
}
exports.createMessageHead = createMessageHead;
